
import React from 'react';
import { motion } from 'framer-motion';
import { Event } from '@/lib/types';
import EventList from '../EventList';
import { getUpcomingEvents } from '@/lib/eventFilters';
import { Calendar } from 'lucide-react';

interface UpcomingEventsSectionProps {
  events?: Event[];
  onEventClick?: (event: Event) => void;
}

const UpcomingEventsSection: React.FC<UpcomingEventsSectionProps> = ({ 
  events = [],
  onEventClick 
}) => {
  // Get the upcoming events, either from provided events or fallback to an empty array
  const upcomingEvents = getUpcomingEvents(events).slice(0, 6);
  
  // If no upcoming events, return null to not render the section
  if (upcomingEvents.length === 0) {
    return null;
  }

  return (
    <motion.section 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="py-16 px-4 bg-medihub-lightBg font-sans"
    >
      <div className="container mx-auto">
        <div className="flex items-center mb-8 gap-2">
          <div className="bg-medihub-primary/10 p-2 rounded-full">
            <Calendar className="h-6 w-6 text-medihub-primary" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900">Közelgő események</h2>
        </div>
        
        <EventList 
          events={upcomingEvents} 
          limit={6} 
          showFilters={false}
          loading={events.length === 0}
          onEventClick={onEventClick}
        />
        
        <div className="mt-8 text-center">
          <a 
            href="/calendar" 
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            Összes esemény megtekintése
          </a>
        </div>
      </div>
    </motion.section>
  );
};

export default UpcomingEventsSection;
